export default `
	imageResponsive {
		...on ImageResponsiveItem {
			imageDesktop {
				url
				kind
				extension
			}
			imageMobile {
				url
				kind
				extension
			}
		}
	}
`;
